// added sidechain
import Sidechain from "@nprapps/sidechain";
import { select } from "async";
const guest = Sidechain.registerGuest({ sentinel: "st" });

guest.sendMessage({
    type: "analytics",
    eventCategory: "interaction",
    eventAction: "click",
    eventLabel: "etc",
});
//end sidechain

require("component-responsive-frame/child");

// lazy load images and loopers
var lazyImages = [].slice.call(document.querySelectorAll(".lazy"));

const width  = window.innerWidth || document.documentElement.clientWidth ||
document.body.clientWidth;

const height = window.innerHeight|| document.documentElement.clientHeight||
document.body.clientHeight;



var full_height = Math.max( document.body.scrollHeight, document.body.offsetHeight,
                       document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight );

console.log(full_height + " " + document.documentElement.scrollHeight);

var size = "small";

if (width > 500){
  size = "medium";
} else {};


var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
               navigator.userAgent &&
               navigator.userAgent.indexOf('CriOS') == -1 &&
               navigator.userAgent.indexOf('FxiOS') == -1;

const config = {
  rootMargin: `${height}px 0px ${height}px 0px`
};


